// externals
import styled, { css } from 'styled-components';
import { Grid } from '@interstate/components/Grid';
import { toRem } from '@makemydeal/dr-dash-components';

export const TradeVinContainer = styled('div')`
    display: flex;
    flex-grow: 1;
`;

export const TradeVinDecodeContainer = styled.div<{ disabled?: boolean }>`
    position: relative;
    ${(props) =>
        css`
            [name='vin-decode-input']:focus {
                box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #005ba8;
            }

            ${props.disabled && `.help-block__wrapper { display: none; }`}
        `};
`;

export const StyledOdometerGridContainer = styled(Grid)`
    & label {
        white-space: nowrap !important;
    }
`;

export const TradeMultipleVIN = styled.div`
    position: absolute;
    width: 100%;
    padding: 8px 0;
    border-radius: 0.25rem;
    border: 1px solid #cacfd9;
    box-shadow: 0 6px 12px rgba(22, 23, 26, 0.1);
    background-color: #fff;
    z-index: 6;
    top: 100%;

    > p {
        text-align: left;
        color: #6d727a;
        cursor: pointer;
        padding: 4px 20px;
        margin: 0;

        &:hover {
            background-color: #2b6bdd;
            color: #fff;
        }
    }
`;

export const BarcodePlaceholder = styled.div`
    position: absolute;
    left: ${toRem(8)};
    top: 70%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    gap: ${toRem(6)};
    pointer-events: none;
    color: #999;
    font-size: ${toRem(14)};
`;

export const DetailContainer = styled.div`
    display: flex;
    flex-direction: column;
`;

export const TradeDecode = styled.div`
    position: absolute;
    right: 0;
    top: -4px;
`;
export {};
